import axios from 'axios';

// Create an Axios instance
const apiPrivate = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    withCredentials: true
});

export default apiPrivate;
